/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap-site');
import Vue from 'vue';
import Mixin from './components/Mixin.js';

// site
import CadfaPrice from './components/CadfaPrice';
import SiteGuestCommentForm from './components/site/GuestCommentForm';
import ProductImages from './components/ProductImages';
import ObjectComments from './components/site/ObjectComments';
import AddToCart from './components/site/AddToCart';
import Cart from './components/site/Cart';
import MiniCart from './components/site/MiniCart';
import SidebarCart from './components/site/SidebarCart';

const app = new Vue({
	mixins: [Mixin],
	el: '#app',
	components: {
        // site
        CadfaPrice,
        SiteGuestCommentForm,
        ProductImages,
        ObjectComments,
        AddToCart,
        Cart,
        MiniCart,
        SidebarCart,
	},
	data() {
		return {
			loading: false,
			toastr: require('toastr'),
			baseURL: document.head.querySelector('base') ? document.head.querySelector('base').href : '',
            cart: null,
		}
	},
	methods: {},
	mounted() {
		if (this.toastr) {
			this.toastr.options.newestOnTop = true;
			this.toastr.options.positionClass = 'toast-top-center';
			this.toastr.options.timeOut = '5000';
			//this.toastr.options.closeButton = true;
			this.toastr.options.progressBar = true;
		}

		/*
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("/sw.js")
                .then(reg => {
                    console.log("Service worker registred successfully", reg);
                })
                .catch(err => {
                    console.log("service worker not registred !!", err);
                });
        }*/
	},
});
